<template>
  <el-button
    :type="type"
    :size="size?size:$parent.elFormItemSize?$parent.elFormItemSize:'small'"
    :icon="icon && icon.indexOf('el-') != -1 ? icon : ''"
    @click="btnClick"
    :plain="plain"
    :disabled="disabled"
    :loading="loading"
    
  >
    <svg-icon
      v-if="icon && icon.indexOf('el-') == -1"
      :icon-class="icon"
      style="margin-right:4px"
    ></svg-icon>
    <slot>
      {{ name }}
    </slot>
  </el-button>
</template>
<script>
import SvgIcon from "../../components/SvgIcon.vue";
export default {
  name: "sino-button",
  components: {
    SvgIcon,
  },
  props: {
    size: { type: String, default: "medium" },
    icon: {
      type: String,
      default: "",
    },
    disabled: {
      //按钮是否禁用
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    name: {
      //按钮名称
      type: String,
      default: "",
    },
    plain: {
      type: Boolean,
      default: false,
    },
    type: {
      //按钮类型
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    btnClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
.el-button{
  font-weight: normal;
}
</style>